import React, { Component } from "react";
import PropTypes from "prop-types";
// Styles
import "./tooltip.css";

class Tooltip extends Component {
  constructor(props) {
    super(props);

    this.state = {
      displayTooltip: false
    };
  }

  hideTooltip = () => {
    this.setState({ displayTooltip: false });
  };

  showTooltip = () => {
    this.setState({ displayTooltip: true });
  };

  render() {
    const { children, message, position } = this.props;
    const { displayTooltip } = this.state;

    return (
      <span className="customTooltip" onMouseLeave={this.hideTooltip}>
        {displayTooltip && (
          <div className={`customTooltip-bubble customTooltip-${position}`}>
            <div className="customTooltip-message">{message}</div>
          </div>
        )}
        <span
          className="customTooltip-trigger"
          onFocus={this.showTooltip}
          onMouseOver={this.showTooltip}
        >
          {children}
        </span>
      </span>
    );
  }
}

Tooltip.defaultProps = {
  position: `top`
};

Tooltip.propTypes = {
  children: PropTypes.element.isRequired,
  message: PropTypes.string.isRequired,
  position: PropTypes.oneOf([`top`, `right`, `bottom`, `left`])
};

export default Tooltip;
